// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"71":"hotel-reviews","320":"sustainability","400":"map-content-resort"}[chunkId] || chunkId) + "." + {"71":"f72c3dc4b421cc800f51","86":"de4b1864fa3de9924cc2","320":"06429672a2807dfee727","400":"a684ad5c3e9d8c9b7797","464":"1d862bc91512eabb4c01"}[chunkId] + ".js";
};